import { createFileRoute } from "@tanstack/react-router";
import { categoryHead } from "@/lib/seo";
import { CategoryHero } from "@/components/CategoryHero";
import { ProductGrid } from "@/components/ProductGrid";
import { useCollectionProducts } from "@/lib/use-catalog";
import { newArrivals, lookProducts, accessories } from "@/lib/catalog";
const beachwearAsset = { url: "/img/beachwear-sunset.webp" };

export const Route = createFileRoute("/beachwear")({
  head: () =>
    categoryHead({
      path: "/beachwear",
      title: "Beachwear Femme au Maroc | SUNSET Concept Store",
      description:
        "Ensembles de plage, robes et jupes crochet pour l'été. Dès 199 DH, livraison partout au Maroc et paiement à la livraison.",
      socialDescription:
        "Ensembles, robes et jupes de plage SUNSET Concept Store. Livraison partout au Maroc, paiement à la livraison.",
      name: "Beachwear",
      image: "/og/beachwear.jpg",
      imageAlt: "Sélection beachwear Sunset Concept Store au coucher de soleil",
      products: localProducts,
    }),
  component: BeachwearPage,
});

const localProducts = [...newArrivals, ...lookProducts, ...accessories].filter(
  (p) => p.category === "Beachwear",
);

function BeachwearPage() {
  const products = useCollectionProducts("/beachwear", localProducts, /beachwear/i);
  return (
    <>
      <CategoryHero
        image={beachwearAsset.url}
        imageAlt="Sélection beachwear Sunset Concept Store au coucher de soleil méditerranéen"
        eyebrow="Collection"
        title="Beachwear"
        subtitle="Maillots, ensembles et robes de plage pensés pour vos journées au soleil."
        imagePosition="sm:object-[50%_45%]"
      />
      <ProductGrid
        products={products}
        placeholderCount={8}
        title="Nos pièces Beachwear"
        eyebrow="Nouveautés"
        subtitle="Des silhouettes légères pour vivre l'été avec élégance."
        emptyMessage={
          <>
            <p className="text-sm text-muted-foreground sm:text-base">
              La collection Beachwear sera bientôt en ligne.
            </p>
            <p className="label-xs mt-3 text-accent">Revenez très vite</p>
          </>
        }
      />
    </>
  );
}
